import React, { useEffect } from 'react';

import * as echarts from 'echarts';
import { Typography } from '@mui/material';

import { ChartWrapper } from './styles';

export const LineChart = ({ id, label, width, height, option }) => {
  useEffect(() => {
    const chartDom = document.getElementById(id);
    const myChart = echarts.init(chartDom, null, {
      width,
      height,
    });

    if (option) myChart.setOption(option);

    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Typography
        fontWeight='700' variant='pb5' color='primary.grey4'>
        {label}
      </Typography>
      <ChartWrapper
        id={id} height={height}
      />
    </>
  );
};
